import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-accordion' },
  selector: 'pulse-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  activeRoute: string;

  @Input() menu: any = [
    {
      title: 'Demographic',
      options: [
        {
          id: 'company-search/:countryId/:companyId/#location',
          title: 'Location',
        },
        {
          id: 'company-search#company_size',
          title: 'Company size',
        },
        {
          id: 'company-search#industry',
          title: 'Industry',
        },
        {
          id: 'company-search#company_type',
          title: 'Company type',
        },
        {
          id: 'company-search#contacts',
          title: 'Contacts',
        },
      ],
    },
    {
      title: 'Advanced',
      options: [
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
      ],
    },
    {
      title: 'Industry info',
      options: [
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
        {
          title: 'Location',
        }
      ],
    },
    {
      title: 'Financial',
      options: [
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
        {
          title: 'Location',
        },
      ],
    },
  ];

  constructor(public router: Router) {}

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
      }
    });
  }

  redirect(route: string) {
    this.router.navigate([`${route}`]);
  }

  isActive(route: string) {
    return this.activeRoute.includes(route);
  }
}
